import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SpriteIconsComponent } from './sprite-icons/sprite-icons.component';

@Component({
  selector: 'pds-atoms-library',
  template: `
    <p>
      atoms-library works!
    </p>
  `,
  styles: [
  ],
  encapsulation: ViewEncapsulation.None
})
export class AtomsLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
